import React from 'react';
import { Box, Tooltip, Typography, Chip } from '@mui/material';
import { lastNoteStyle } from 'src/styles/NewLead';
import { tableCellInnerBoxStyle } from 'src/styles/NewLeadTableRowStyle';
import Iconify from 'src/components/Iconify';

// Helper function to check if a note is an AI note
const parseAINote = (noteContent) => {
    if (!noteContent) return null;
    try {
        const parsed = JSON.parse(noteContent);
        if (parsed && parsed.AI_NOTES === true) {
            return parsed;
        }
    } catch (e) {
        // Not a JSON note, return null
    }
    return null;
};

const LastNoteCell = ({ handleArchivedNavigate }) => ({
    field: 'archive_note',
    headerName: 'Archive note',
    sortable: false,
    editable: false,
    width: 200,
    minWidth: 150,
    renderCell: (params) => {
        const noteContent = params?.row?.lead_notes?.additional_notes;
        const aiNoteData = parseAINote(noteContent);

        const renderNoteContent = () => {
            if (!params?.row?.lead_notes) {
                return '';
            }
            if (aiNoteData) {
                return (
                    <Chip
                        icon={<Iconify icon="mdi:robot-outline" width={16} height={16} />}
                        label="AI Call Summary"
                        size="small"
                        sx={{
                            bgcolor: 'rgba(118, 53, 220, 0.08)',
                            color: '#7635dc',
                            fontWeight: 600,
                            fontSize: '0.75rem',
                            '& .MuiChip-icon': {
                                color: '#7635dc',
                            },
                        }}
                    />
                );
            }
            return (
                <Tooltip title={noteContent}>
                    <Box sx={lastNoteStyle}>
                        <Typography variant='subtitle2' sx={{ fontWeight: '400', ...lastNoteStyle }}>
                            {noteContent || ''}
                        </Typography>
                    </Box>
                </Tooltip>
            );
        };

        return (
            <Box onClick={() => handleArchivedNavigate(params?.row)} sx={tableCellInnerBoxStyle}>
                {renderNoteContent()}
            </Box>
        );
    },
});

export default LastNoteCell;
